import { trackEvent } from './analytics';

export function reportWebVitals() {
  import('web-vitals').then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
    const sendToAnalytics = ({ name, delta, id }) => {
      trackEvent('web_vitals', {
        metric_name: name,
        metric_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        metric_id: id,
      });
    };

    onCLS(sendToAnalytics);
    onFCP(sendToAnalytics);
    onINP(sendToAnalytics);
    onLCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
  });
}
